import Splide from "@splidejs/splide";
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
import {Lightbox} from "./pswp";

window.addEventListener("load", () => {
    const gallery_slides = document.querySelectorAll<HTMLElement>(".gallery-splide");
    const post_slides = document.querySelectorAll<HTMLElement>(".post-splide");
    const product_slides = document.querySelectorAll<HTMLElement>(".products-splide");
    const brands_slides = document.querySelectorAll<HTMLElement>(".brands-splide");
    const review_splides = document.querySelectorAll<HTMLElement>('.splide-reviews');

    review_splides?.forEach(reviews => {
        const splide = new Splide(reviews, {
            type: 'slide',
            perPage: 3,
            arrows: true,
            pagination: false,
            omitEnd: false,
            focus: 0,
            perMove: 1,
            gap: '20px',
            breakpoints: {
                575: {
                    perPage: 1,
                    gap: 0,
                },
                991: {
                    perPage: 2
                },
            }
        });

        splide.mount();
    });

    gallery_slides?.forEach(gallery => {
        const splide = new Splide(gallery, {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            gap: '16px',
            arrows: true,
            pagination: true,
            omitEnd: false,
            focus: 0,
            breakpoints: {
                575: {
                    perPage: 2
                },
                767: {
                    perPage: 3
                }
            }
        });

        splide.on('mounted', () => {
            new Lightbox(gallery);
        });

        splide.mount();
    })

    post_slides?.forEach(posts => {
        const splide = new Splide(posts, {
            type: 'slide',
            perPage: 3,
            perMove: 1,
            gap: '20px',
            arrows: true,
            pagination: true,
            omitEnd: false,
            focus: 0,
        });

        splide.mount();
    });

    product_slides?.forEach(products => {
        const slides = products.querySelectorAll<HTMLElement>('.product');

        if (slides.length <= 4) {
            products.classList.remove('splide');
            return;
        } else {
            slides?.forEach(slide => {
                slide.classList.add('splide__slide');
            });

            const splide = new Splide(products, {
                type: 'slide',
                perPage: 4,
                perMove: 1,
                gap: '16px',
                arrows: true,
                pagination: true,
                omitEnd: false,
                focus: 0,
            });

            splide.mount();
        }
    });

    brands_slides?.forEach(brands => {
        const slides = brands.querySelectorAll('.splide__slide');

        if (slides.length <= 4) {
            brands.classList.remove('splide');
            return;
        }

        const splide = new Splide(brands, {
            type: 'loop',
            gap: '64px',
            autoWidth: true,
            focus: 0,
            omitEnd: true,
            clones: 6,
            autoScroll: {
                speed: 0.5,
                pauseOnFocus: false,
                pauseOnHover: false,
            },
            arrows: false,
            pagination: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            drag: false,
        });

        splide.mount({AutoScroll});
    });
});
